import * as React from "react";
import * as Modal from "react-modal";



interface IModalMessageProps {
  height?: string;
  width?: string;
  maxWidth?: string;
  onRequestClose: Function;
  isOpen: boolean;
  label: string;
  message: string;
  positiveResponseLabel?: string;
  positiveResponseClass?: string;
  negativeResponseLabel?: string;
  negativeResponseClass?: string;
  onPositiveResponse?: Function;
  onNegativeResponse?: Function;
}

export default class ModalMessage extends React.PureComponent<IModalMessageProps, any> {
  constructor(props: IModalMessageProps) {
    super(props);
    this.onNegativeResponseClick = this.onNegativeResponseClick.bind(this);
    this.onPositiveResponseClick = this.onPositiveResponseClick.bind(this);
  }

  onNegativeResponseClick() {
    this.props.onNegativeResponse();
  }
  onPositiveResponseClick() {
    this.props.onPositiveResponse();
  }

  render() {
    const modalStyle = {
      overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 100
      },
      content: {
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        margin: "auto",
        height: this.props.height || "200px",
        width: this.props.width || "90%",
        maxWidth: this.props.maxWidth || "500px",
        background: "#ffffff",
        padding: "0px",
        border: "0px solid #ccc",
        borderRadius: "0px",
      }
    };

    return (
      <Modal
        isOpen={this.props.isOpen}
        style={modalStyle}
        contentLabel={this.props.label}
        onRequestClose={this.props.onRequestClose}
        appElement={document.getElementById('app')}
      >
        {
          <div style={{ borderTop: "solid 1px #ada3a4", backgroundColor: "#ffffff" }}>
            <div style={{ backgroundColor: "#f8f6f7", display: "block", color: "#636363", borderBottom: "solid 1px #e3e3e3" }} className="p-2">
              <i className="pull-right fa fa-times" onClick={this.onNegativeResponseClick} />
              <strong> {this.props.label}</strong>
            </div>
            <div className="mx-3 my-3">
              <p className="py-2">{this.props.message}</p>
              <div className="pull-right">
                {this.props.negativeResponseLabel &&
                  this.props.onNegativeResponse ? (
                    <button
                      type="button"
                      onClick={this.onNegativeResponseClick}
                      className={`btn ${this.props.negativeResponseClass} mr-2`}
                    >
                      {this.props.negativeResponseLabel}
                    </button>
                  ) : (
                    undefined
                  )}
                {this.props.positiveResponseLabel &&
                  this.props.onPositiveResponse ? (
                    <button
                      type="button"
                      onClick={this.onPositiveResponseClick}
                      className={`btn ${this.props.positiveResponseClass}`}
                    >
                      {this.props.positiveResponseLabel}
                    </button>
                  ) : (
                    undefined
                  )}
              </div>
            </div>
          </div>
        }
      </Modal>
    );
  }
}

